/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
// import { PropTypes as MicromagPropTypes } from '@micromag/core';

import { useOrganisation } from '../../../contexts/OrganisationContext';
import MainLayout from '../../layouts/Main';
import Page from '../../partials/Page';

const propTypes = {
    // location: MicromagPropTypes.location.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const OrganisationInactivePage = ({ className }) => {
    const organisation = useOrganisation();

    return (
        <MainLayout nav={[]}>
            <Page
                title={organisation !== null ? organisation.name : null}
                className={classNames([
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                <div className="card">
                    <div className="card-body">
                        <FormattedMessage
                            defaultMessage="Please contact us to activate your organisation."
                            descrition="Organisation inactive title"
                        />
                    </div>
                </div>
            </Page>
        </MainLayout>
    );
};

OrganisationInactivePage.propTypes = propTypes;
OrganisationInactivePage.defaultProps = defaultProps;

export default OrganisationInactivePage;
